/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResourceDeleted
 */
export interface ResourceDeleted {
    /**
     * 
     * @type {string}
     * @memberof ResourceDeleted
     */
    id: string;
}

/**
 * Check if a given object implements the ResourceDeleted interface.
 */
export function instanceOfResourceDeleted(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ResourceDeletedFromJSON(json: any): ResourceDeleted {
    return ResourceDeletedFromJSONTyped(json, false);
}

export function ResourceDeletedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceDeleted {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function ResourceDeletedToJSON(value?: ResourceDeleted | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

